import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CodeEditorComponent } from '../code-editor/code-editor.component';

@Component({
  selector: 'noovle-json-viewer',
  standalone: true,
  imports: [
    CommonModule,
    CodeEditorComponent,
    FormsModule,
    FontAwesomeModule,
    NgbTooltipModule,
  ],
  templateUrl: './json-viewer.component.html',
  styleUrls: ['./json-viewer.component.scss'],
})
export class JsonViewerComponent {
  title: string;
  json: any;

  constructor(public activeModal: NgbActiveModal) {}

  copyToClipboard() {
    if (typeof this.json === 'string') {
      navigator.clipboard.writeText(this.json);
    } else {
      navigator.clipboard.writeText(this.json.value);
    }
  }
}
